<!--@format-->
<template>
    <div class="recipient-element-popup">
        <p class="text">
            You're about to remove a recipient, however, it has fields assigned to it. You can
            choose to re-assign the fields to another recipient.
            {{ element.recipientToDelete.name }} will not have access to this document anymore.
        </p>
        <div class="recipients-container">
            <div
                v-for="recipient in possibleRecipients"
                :key="recipient.id"
                class="radio-option"
                :class="{ selected: recipient.id === currentSelected.id }"
                @click="selectOption(recipient)"
            >
                <div class="radio-button-container-recipients">
                    <div class="radio-option-label-container">
                        <div class="recipient circle">
                            <div class="inside"></div>
                        </div>
                        <div class="radio-option-label">{{ recipient.name }}</div>
                    </div>
                </div>
            </div>
        </div>
        <div class="app-popup-actions inner-actions">
            <app-button class="tertiary-btn" @click="closePopup"> Cancel </app-button>
            <app-button class="removeNotIcon" @click="onDeleteSigner"> Delete </app-button>
        </div>
    </div>
</template>

<script>
const AppButton = () => import('@/components/common/app-button');
import EventBus from '@/scripts/event-bus';
import { cloneDeep } from 'lodash';

export default {
    name: 'recipient-element-popup',

    components: {
        'app-button': AppButton,
    },

    props: {
        element: {
            type: Object,
            required: true,
        },
    },

    data() {
        return {
            currentSelected: { id: '' },
        };
    },

    computed: {
        possibleRecipients() {
            return this.element.recipients;
        },
    },

    created() {
        this.possibleRecipients.unshift({
            id: 'nobody',
            name: 'Nobody',
        });
        this.currentSelected = this.possibleRecipients[0];
    },

    methods: {
        selectOption(option) {
            this.currentSelected = option;
        },

        onDeleteSigner() {
            EventBus.$emit('popup:return-assigned-recipient', {
                newSigner: cloneDeep(this.currentSelected),
                oldSigner: cloneDeep(this.element.recipientToDelete),
            });
            this.closePopup();
        },

        closePopup() {
            this.$emit('close');
        },
    },
};
</script>

<style>
.recipient-element-popup {
    max-width: 803px;
    width: 100%;
    color: #ffffff;
    height: 100%;
    position: static;
    overflow: auto;
}

.recipient-element-popup .recipients-container {
    max-height: 224px;
    overflow: auto;
}

.recipient-element-popup .recipients-container::-webkit-scrollbar {
    width: 10px;
    height: 10px;
}

.recipient-element-popup .recipients-container::-webkit-scrollbar-track {
    background-color: #f8f8f8;
}

.recipient-element-popup .recipients-container::-webkit-scrollbar-thumb {
    background-color: #cac6cb;
    border-radius: 5px;
}

.recipient-element-popup .text {
    font: normal normal normal 22px/37px Nunito;
    letter-spacing: 0px;
    color: #382153;
}

.recipient-element-popup .radio-option-label {
    font: normal normal normal 16px/24px Roboto;
    color: #382153;
}

.recipient-element-popup .radio-button-container-recipients {
    display: flex;
}

.recipient-element-popup .radio-option .radio-button-container-recipients {
    position: relative;
    display: flex;
    flex-direction: column;
    margin-bottom: 9px;
}

.recipient-element-popup .radio-option.selected .radio-button-container-recipients {
    opacity: 0.5;
}

.recipient-element-popup
    .radio-option
    .radio-button-container-recipients
    .radio-option-label-container {
    display: flex;
    align-items: center;
    position: relative;
    gap: 10px;
}

.recipient-element-popup .radio-button-container-recipients .recipient.circle {
    display: block;
    position: relative;
    border-radius: 100%;
    height: 30px;
    width: 30px;
    border: 2px solid #382153;
    background: #e9e9ef 0% 0% no-repeat padding-box;
}

.recipient-element-popup .radio-button-container-recipients .recipient.circle::before {
    display: block;
    position: absolute;
    content: '';
    border-radius: 100%;
    height: 18px;
    width: 18px;
    top: 4px;
    left: 4px;
    margin: auto;
}

.recipient-element-popup
    .radio-option.selected
    .radio-button-container-recipients
    .recipient.circle {
    border: 2px solid rgb(56 33 60);
}

.recipient-element-popup
    .radio-option.selected
    .radio-button-container-recipients
    .recipient.circle::before {
    border: 2px solid rgb(56 33 60);
    background: rgb(56 33 60);
}

.recipient-element-popup .app-popup-actions {
    display: flex;
    border-top: 2px solid #e9e9ef;
    justify-content: center;
    gap: 14px;
    padding-top: 24px;
    margin-top: 30px;
}

.recipient-element-popup .app-popup-actions .app-button {
    min-width: 152px;
}
</style>
